import useFlag from 'app/hooks/useFlag';
import { useAuth } from 'context';
import { userInfoApi } from 'services/api/user-info/queries';
import { FeatureName } from 'types/entities/MobileSettings';

export default function useGetUserInfoQuery() {
  const isSingleSignOnFeatureEnabled = useFlag(FeatureName.SINGLE_SIGN_ON);
  const { isAuthenticated } = useAuth();

  const v1Query = userInfoApi.useGetUserInfoV1Query(undefined, {
    skip: isSingleSignOnFeatureEnabled || !isAuthenticated,
  });

  const v2Query = userInfoApi.useGetUserInfoV2Query(undefined, {
    skip: !isSingleSignOnFeatureEnabled || !isAuthenticated,
  });

  return isSingleSignOnFeatureEnabled ? v2Query : v1Query;
}
